<!-- Sidebar Toggle Button (Mobile) -->
<button
  id="sidebar-toggle"
  type="button"
  class="lg:hidden fixed top-4 left-4 z-50 p-2 text-gray-600 bg-white rounded-lg shadow-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
  (click)="toggleSidebar()">
  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
  </svg>
</button>

<!-- Sidebar Overlay (Mobile) -->
<div
  *ngIf="sidebarOpen"
  class="lg:hidden fixed inset-0 z-40 bg-gray-900 bg-opacity-10 backdrop-blur-sm transition-opacity duration-300"
  (click)="closeSidebar()">
</div>

<!-- Sidebar -->
<aside
  id="sidebar"
  class="fixed top-0 left-0 z-40 h-screen transition-all duration-300 ease-in-out bg-white border-r border-gray-200 shadow-lg"
  [class.w-72]="!sidebarCollapsed"
  [class.w-16]="sidebarCollapsed"
  [class.translate-x-0]="sidebarOpen"
  [class.-translate-x-full]="!sidebarOpen"
  [class.lg:translate-x-0]="true">

  <!-- Sidebar Header -->
  <div class="flex items-center justify-between p-6 border-b border-gray-200"
       [class.px-3]="sidebarCollapsed"
       [class.justify-center]="sidebarCollapsed">
    <div class="flex items-center" [class.justify-center]="sidebarCollapsed" *ngIf="!sidebarCollapsed">
      <img
        class="h-10 w-auto"
        [src]="sanitize('../assets/public/images/banner_2.png')"
        alt="Logo" />
    </div>

    <!-- Sidebar Collapse Button (Desktop) - Moved to header -->
    <button
      *ngIf="!sidebarCollapsed"
      id="sidebar-collapse-toggle"
      type="button"
      class="hidden lg:block p-2 text-gray-600 bg-white rounded-lg shadow-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300 border border-gray-200"
      (click)="toggleSidebarCollapse()">
      <svg class="w-4 h-4 transition-transform duration-300"
           fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
      </svg>
    </button>

    <button
      *ngIf="!sidebarCollapsed"
      class="lg:hidden p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg"
      (click)="closeSidebar()">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
  </div>

  <!-- Sidebar Header (Collapsed) - Only collapse button, no icon -->
  <div *ngIf="sidebarCollapsed" class="absolute top-6 right-4 z-50">
    <button
      id="sidebar-collapse-toggle-collapsed"
      type="button"
      class="p-2 text-gray-600 bg-white rounded-lg shadow-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300 border border-gray-200"
      (click)="toggleSidebarCollapse()">
      <svg class="w-4 h-4 transition-transform duration-300"
           fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
      </svg>
    </button>
  </div>

  <!-- User Profile Section -->
  <div *ngIf="isAuth && !sidebarCollapsed" class="p-6 border-b border-gray-200">
    <div class="flex items-center space-x-3">
      <div class="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
        <i class="fas fa-user text-white text-sm"></i>
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium text-gray-900 truncate">
          {{sessionUser?.name}} {{sessionUser?.lastName}}
        </p>
        <p class="text-xs text-gray-500 truncate">
          {{sessionUser?.username}}
        </p>
      </div>
    </div>
  </div>

  <!-- User Profile Section (Collapsed) - Completely removed -->
  <!-- No user profile section when collapsed to avoid the blue icon -->

  <!-- Navigation Menu -->
  <nav class="sidebar-nav flex-1 py-6 space-y-2 overflow-y-auto"
       [class.px-4]="!sidebarCollapsed"
       [class.px-2]="sidebarCollapsed">

    <!-- Dashboard - OCULTO -->
    <!--
    <a
      [routerLink]="['/console/dashboard']"
      class="flex items-center px-4 py-3 text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group"
      [class.bg-blue-50]="menuOption === 0"
      [class.text-blue-700]="menuOption === 0"
      [class.border-r-4]="menuOption === 0"
      [class.border-blue-500]="menuOption === 0"
      (click)="setOptionMenu(0)">
      <i class="fas fa-tachometer-alt w-5 h-5 mr-3 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 0"></i>
      <span>Dashboard</span>
    </a>
    -->

    <!-- Contactos -->
    <a
      *ngIf="hasRbac ? canAccessModule('contactos') : _auth.IsPermitid(['OWNER','ANALIST','EJECUTIVE','ADMIN','FINANCIAL','ACCOUNTING_ANALYST'])"
      [routerLink]="['/console/create-constacts']"
      class="flex items-center text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group relative"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-3]="!sidebarCollapsed"
      [class.py-2]="sidebarCollapsed"
      [class.justify-center]="sidebarCollapsed"
      [class.bg-blue-50]="menuOption === 1"
      [class.text-blue-700]="menuOption === 1"
      [class.border-r-4]="menuOption === 1 && !sidebarCollapsed"
      [class.border-blue-500]="menuOption === 1 && !sidebarCollapsed"
      [class.bg-blue-100]="menuOption === 1 && sidebarCollapsed"
      (click)="setOptionMenu(1)"
      [title]="sidebarCollapsed ? 'Contactos' : ''">
      <i class="fas fa-users w-5 h-5 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 1"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Contactos</span>
    </a>

    <!-- Ventas -->
    <a
      *ngIf="hasRbac ? canAccessModule('ventas') : _auth.IsPermitid(['OWNER','ANALIST','EJECUTIVE','ADMIN','FINANCIAL'])"
      [routerLink]="['/console/ventas']"
      class="flex items-center text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group relative"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-3]="!sidebarCollapsed"
      [class.py-2]="sidebarCollapsed"
      [class.justify-center]="sidebarCollapsed"
      [class.bg-blue-50]="menuOption === 2"
      [class.text-blue-700]="menuOption === 2"
      [class.border-r-4]="menuOption === 2 && !sidebarCollapsed"
      [class.border-blue-500]="menuOption === 2 && !sidebarCollapsed"
      [class.bg-blue-100]="menuOption === 2 && sidebarCollapsed"
      (click)="setOptionMenu(2)"
      [title]="sidebarCollapsed ? 'Ventas' : ''">
      <i class="fas fa-shopping-bag w-5 h-5 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 2"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Ventas</span>
    </a>

    <!-- Finanzas -->
    <a
      *ngIf="hasRbac ? canAccessModule('finanzas') : _auth.IsPermitid(['OWNER','ANALIST','FINANCIAL','ACCOUNTING_ANALYST'])"
      [routerLink]="['/console/finanzas2']"
      class="flex items-center text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group relative"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-3]="!sidebarCollapsed"
      [class.py-2]="sidebarCollapsed"
      [class.justify-center]="sidebarCollapsed"
      [class.bg-blue-50]="menuOption === 4"
      [class.text-blue-700]="menuOption === 4"
      [class.border-r-4]="menuOption === 4 && !sidebarCollapsed"
      [class.border-blue-500]="menuOption === 4 && !sidebarCollapsed"
      [class.bg-blue-100]="menuOption === 4 && sidebarCollapsed"
      (click)="setOptionMenu(4)"
      [title]="sidebarCollapsed ? 'Finanzas' : ''">
      <i class="fas fa-chart-line w-5 h-5 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 4"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Finanzas</span>
    </a>

    <!-- Transacciones 3DS: movido a Cobranza (card) y su Configuración a Parámetros de Sistema -->

    <!-- Divider 1 -->
    <div *ngIf="!sidebarCollapsed && (hasRbac ? (canAccessModule('cobranza') || canAccessModule('credito')) : _auth.IsPermitid(['OWNER','ANALIST','EJECUTIVE','ADMIN','FINANCIAL']))" class="py-2">
      <div class="border-t border-gray-200"></div>
    </div>

    <!-- Cobranza -->
    <a
      *ngIf="hasRbac ? canAccessModule('cobranza') : _auth.IsPermitid(['OWNER','ANALIST','EJECUTIVE','ADMIN','FINANCIAL'])"
      [routerLink]="['/console/cobranza']"
      class="flex items-center text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group relative"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-3]="!sidebarCollapsed"
      [class.py-2]="sidebarCollapsed"
      [class.justify-center]="sidebarCollapsed"
      [class.bg-blue-50]="menuOption === 6"
      [class.text-blue-700]="menuOption === 6"
      [class.border-r-4]="menuOption === 6 && !sidebarCollapsed"
      [class.border-blue-500]="menuOption === 6 && !sidebarCollapsed"
      [class.bg-blue-100]="menuOption === 6 && sidebarCollapsed"
      (click)="setOptionMenu(6)"
      [title]="sidebarCollapsed ? 'Cobranza' : ''">
      <i class="fas fa-hand-holding-usd w-5 h-5 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 6"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Cobranza</span>
    </a>

    <!-- Crédito -->
    <a
      *ngIf="hasRbac ? canAccessModule('credito') : _auth.IsPermitid(['OWNER','ANALIST','EJECUTIVE','ADMIN','FINANCIAL'])"
      [routerLink]="['/console/credito']"
      class="flex items-center text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group relative"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-3]="!sidebarCollapsed"
      [class.py-2]="sidebarCollapsed"
      [class.justify-center]="sidebarCollapsed"
      [class.bg-blue-50]="menuOption === 7"
      [class.text-blue-700]="menuOption === 7"
      [class.border-r-4]="menuOption === 7 && !sidebarCollapsed"
      [class.border-blue-500]="menuOption === 7 && !sidebarCollapsed"
      [class.bg-blue-100]="menuOption === 7 && sidebarCollapsed"
      (click)="setOptionMenu(7)"
      [title]="sidebarCollapsed ? 'Crédito' : ''">
      <i class="fas fa-credit-card w-5 h-5 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 7"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Crédito</span>
    </a>

    <!-- Parámetros de Sistema -->
    <a
      *ngIf="hasRbac ? canAccessModule('config') : _auth.IsPermitid(['OWNER','ANALIST','ADMIN','FINANCIAL'])"
      [routerLink]="['/console/parametros-sistema']"
      class="flex items-center text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group relative"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-3]="!sidebarCollapsed"
      [class.py-2]="sidebarCollapsed"
      [class.justify-center]="sidebarCollapsed"
      [class.bg-blue-50]="menuOption === 8"
      [class.text-blue-700]="menuOption === 8"
      [class.border-r-4]="menuOption === 8 && !sidebarCollapsed"
      [class.border-blue-500]="menuOption === 8 && !sidebarCollapsed"
      [class.bg-blue-100]="menuOption === 8 && sidebarCollapsed"
      (click)="setOptionMenu(8)"
      [title]="sidebarCollapsed ? 'Parámetros de Sistema' : ''">
      <i class="fas fa-cogs w-5 h-5 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 8"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Parámetros de Sistema</span>
    </a>

    <!-- Productos -->
    <a
      *ngIf="hasRbac ? canAccessModule('productos_compra') : _auth.IsPermitid(['OWNER','ANALIST'])"
      [routerLink]="['/console/catalog-products']"
      class="flex items-center text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group relative"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-3]="!sidebarCollapsed"
      [class.py-2]="sidebarCollapsed"
      [class.justify-center]="sidebarCollapsed"
      [class.bg-blue-50]="menuOption === 11"
      [class.text-blue-700]="menuOption === 11"
      [class.border-r-4]="menuOption === 11 && !sidebarCollapsed"
      [class.border-blue-500]="menuOption === 11 && !sidebarCollapsed"
      [class.bg-blue-100]="menuOption === 11 && sidebarCollapsed"
      (click)="setOptionMenu(11)"
      [title]="sidebarCollapsed ? 'Productos de Compra' : ''">
      <i class="fas fa-shopping-bag w-5 h-5 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 11"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Productos de Compra</span>
    </a>

    <!-- Divider 2 -->
    <div *ngIf="!sidebarCollapsed && (hasRbac ? canAccessModule('reportes') : _auth.IsPermitid(['OWNER','ANALIST']))" class="py-2">
      <div class="border-t border-gray-200"></div>
    </div>

    <!-- Reportería -->
    <a
      *ngIf="hasRbac ? canAccessModule('reportes') : _auth.IsPermitid(['OWNER','ANALIST'])"
      [routerLink]="['/console/export']"
      class="flex items-center text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-3]="!sidebarCollapsed"
      [class.py-2]="sidebarCollapsed"
      [class.justify-center]="sidebarCollapsed"
      [class.bg-blue-50]="menuOption === 9"
      [class.text-blue-700]="menuOption === 9"
      [class.border-r-4]="menuOption === 9 && !sidebarCollapsed"
      [class.border-blue-500]="menuOption === 9 && !sidebarCollapsed"
      [class.bg-blue-100]="menuOption === 9 && sidebarCollapsed"
      (click)="setOptionMenu(9)"
      [title]="sidebarCollapsed ? 'Reportería' : ''">
      <i class="fas fa-chart-bar w-5 h-5 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 9"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Reportería</span>
    </a>

    <!-- Simulador de Caja - OCULTO TEMPORALMENTE PARA PRODUCCIÓN -->
    <!--
    <a
      *ngIf="_auth.IsPermitid(['OWNER','ANALIST'])"
      [routerLink]="['/console/caja']"
      class="flex items-center text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors group"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-3]="!sidebarCollapsed"
      [class.py-2]="sidebarCollapsed"
      [class.justify-center]="sidebarCollapsed"
      [class.bg-blue-50]="menuOption === 10"
      [class.text-blue-700]="menuOption === 10"
      [class.border-r-4]="menuOption === 10 && !sidebarCollapsed"
      [class.border-blue-500]="menuOption === 10 && !sidebarCollapsed"
      [class.bg-blue-100]="menuOption === 10 && sidebarCollapsed"
      (click)="setOptionMenu(10)"
      [title]="sidebarCollapsed ? 'Simulador de Caja' : ''">
      <i class="fas fa-cash-register w-5 h-5 text-gray-400 group-hover:text-gray-500"
         [class.text-blue-500]="menuOption === 10"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Pagos desde Caja</span>
    </a>
    -->

    <!-- Divider -->
    <div *ngIf="!sidebarCollapsed" class="py-2">
      <div class="border-t border-gray-200"></div>
    </div>

    <!-- Cerrar Sesión -->
    <button
      (click)="logout()"
      class="w-full flex items-center text-sm font-medium text-red-700 rounded-lg hover:bg-red-50 transition-colors group"
      [class.px-4]="!sidebarCollapsed"
      [class.px-3]="sidebarCollapsed"
      [class.py-2]="true"
      [class.justify-center]="sidebarCollapsed"
      [title]="sidebarCollapsed ? 'Cerrar Sesión' : ''">
      <i class="fas fa-sign-out-alt w-5 h-5 text-red-500"
         [class.mr-3]="!sidebarCollapsed"></i>
      <span *ngIf="!sidebarCollapsed">Cerrar Sesión</span>
    </button>

  </nav>

</aside>

<!-- Main Content Area -->
<main class="transition-all duration-300 ease-in-out lg:pl-72 lg:pr-0"
      [class.lg:pl-16]="sidebarCollapsed"
      [class.lg:pl-72]="!sidebarCollapsed">

  <!-- Top Navigation Bar -->
  <div class="bg-white border-b border-gray-200 sticky top-0 z-30">
    <div class="flex items-center justify-between px-4 py-2">
      <!-- Page Title -->
      <div class="flex items-center">
        <h1 class="text-lg font-semibold text-gray-900">{{ getPageTitle() }}</h1>
      </div>

      <!-- Apps Launcher + User Dropdown -->
      <div *ngIf="isAuth" class="relative flex items-center gap-2">
        <app-apps-launcher></app-apps-launcher>
        <div ngbDropdown placement="bottom-right" class="d-inline-block">
          <button
            ngbDropdownToggle
            id="userDropdown"
            class="flex items-center space-x-2 p-1.5 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 border-0 bg-transparent">
            <div class="w-7 h-7 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
              <i class="fas fa-user text-white text-xs"></i>
            </div>
            <div class="hidden sm:block text-left">
              <p class="text-sm font-medium text-gray-900">
                {{sessionUser?.name}} {{sessionUser?.lastName}}
              </p>
              <p class="text-xs text-gray-500">
                {{sessionUser?.username}}
              </p>
            </div>
            <i class="fas fa-chevron-down text-gray-400 text-xs"></i>
          </button>

          <div ngbDropdownMenu aria-labelledby="userDropdown" class="modern-dropdown-menu">
            <!-- User Info Header -->
            <div class="dropdown-header">
              <div class="user-avatar-large">
                <i class="fas fa-user"></i>
              </div>
              <div class="user-info">
                <div class="user-name">
                  {{sessionUser?.name}} {{sessionUser?.lastName}}
                </div>
                <div class="user-email">
                  {{sessionUser?.username}}
                </div>
              </div>
            </div>

            <div class="dropdown-divider"></div>

            <!-- Dropdown Actions -->
            <div class="dropdown-footer">
              <button
                (click)="logout()"
                class="logout-button">
                <i class="fas fa-sign-out-alt"></i>
                <span>Cerrar Sesión</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Page Content -->
  <div class="min-h-screen bg-gray-50">
    <ng-content></ng-content>
  </div>
</main>
